import { useEffect, useState } from 'react';
import { get } from '../../rest/api';
import { ResultadoData } from '../../model/ResultadoData';
import { resultadoDataMapping } from '../../rest/resultadoDataMapping';
import { URL_API_PRODUCTO_BUSQUEDA, URL_API_PRODUCTO_RUBRO } from '../../constants/urls';
import { ERROR_SERVER_HTTP_CODE } from '../../rest/responseCodes';

export function useResultadoRequest(rubro: string | null, busqueda: string | null) {
  const [data, setData] = useState<ResultadoData>();
  const [loading, setLoading] = useState<boolean>(true);
  const [isError, setError] = useState<boolean>();
  let url: string | undefined = undefined;

  if (rubro) {
    url = `${URL_API_PRODUCTO_RUBRO}${rubro}`;
  } else if (busqueda) {
    url = `${URL_API_PRODUCTO_BUSQUEDA}${busqueda}`;
  }

  const handleResponse = (response: ResultadoData | undefined) => {
    if (response) setData(resultadoDataMapping(response));
    setLoading(false);
  };

  const handleError = (error: any, httpCode?: number) => {
    setData(undefined);
    if (httpCode && httpCode >= ERROR_SERVER_HTTP_CODE) setError(true);

    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    setError(false);
    setData(undefined);
    get(url, handleResponse, handleError);
  }, [url]);

  return [data, loading, isError] as const;
}
